import React from 'react'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import Training from '../Welcome/Training'
import AuthenticationService from '../Security/AuthenticationService'
import './Header.css'
import { Config } from '../../Config'

export default class Help extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage()
    }
    this.hmeInstructionsLink = this.hmeInstructionsLink.bind(this)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    // this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.state.url = Config.storageUrl
  }

  hmeInstructionsLink () {
    const { url } = this.state
    const language = this.state.currentLanguage
    if (language === 1) {
      return (<span />)
    } else {
      return (
        <span className='fright'>
          <a href={url + '/' + t[language].HMECLOUDOperatingInstructionsUrl} target='_blank' className='instruction_link'>{t[language].HMECLOUDOperatingInstructions}</a>
        </span>
      )
    }
  }
  render () {
    const language = this.state.currentLanguage
    return (<div className='fteaser'>
      <div className='csect clear'>
        <div className='helpHeaders'>
          <div><h3>{t[language].HelpFrequentlyAskedQs}</h3></div>
          <div className='operatingInstruction'>{this.hmeInstructionsLink()} </div>
        </div>
        <div className='faq clear'>
          <h5>{t[language].HelpNewFeatures}</h5>
          <ul className='ques'>
            <li>{t[language].HelpNewDashboardOrReport}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpContactYourSalesRep}</span></li>
              </ul>
            </li>
          </ul>
          <h5 translate='' key='password'>{t[language].password}</h5>
          <ul className='ques'>
            <li>{t[language].HelpHowChangePassword}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpSignInClickOnMyAccount}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpWhatIfForgotPass}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpGoHomeClickForgotPass}</span></li>
              </ul>
            </li>
          </ul>
          <h5>{t[language].navbarSettings}</h5>
          <ul className='ques'>
            <li>{t[language].HelpHowSetDayparts}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpAllSettingsInDashboard}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpWhatAreRoles}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpCompanyAdminPowers}</span></li>
                <li>— <span>{t[language].HelpCompanyManagerPowers}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpDeterminePermissionLevel}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpPermissionLevelIsOnMyAccount}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpUpdateEmployeeList}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpAccessUserList}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpAccessZoomSettingsRemotely}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpAccessZoomSettingsInstructions}</span></li>
              </ul>
            </li>
          </ul>
          <h5>{t[language].HelpSubscription}</h5>
          <ul className='ques'>
            <li>{t[language].HelpDoSubscriptionsRenew}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpYesSubscriptionsRenew}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpWhenSubscriptionExpires}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpContactTechSupport}</span></li>
              </ul>
            </li>
            <li translate='' key='HelpCancelMySubscription'>Comment puis-je annuler mon abonnement?</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpCancelationInstructions}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpIfAddStoreSub}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpAddingStoresDiscountedPrice}</span></li>
              </ul>
            </li>
          </ul>
          <h5>{t[language].HelpTroubleshooting}</h5>
          <ul className='ques'>
            <li>{t[language].HelpDashboardNoContent}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpYouMayNeedPremium}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpNewZoomNotShowing}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpConfirmZoomConfigured}</span></li>
                <li>
                  <ol className='answer_ordered'>
                    <li>{t[language].HelpConfirmFirmwareVersion}</li>
                    <li>{t[language].HelpConfirmAdminStatus}</li>
                    <li>{t[language].HelpConfirmTimerOptIn}</li>
                    <li>{t[language].HelpVerifyPortsOpen}</li>
                    <li>{t[language].HelpVerifyActiveAccount}</li>
                  </ol>
                </li>
              </ul>
            </li>
            <li>{t[language].HelpHowToGetHelp}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpContactUs}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpPossibleInnaccurateData}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpHandlingMissingData}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpUnableToConnect}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpConnectingNeedsScripts}</span></li>
              </ul>
            </li>
            <li>{t[language].HelpSystemStatusUnavailable}</li>
            <li className='answer_list'>
              <ul className='answer'>
                <li>— <span>{t[language].HelpStoreIsUnregistered}</span></li>
              </ul>
            </li>
          </ul>
        </div>
        <br />
        <br />
        <p className='contactText'><span>{t[language].HelpContactByEmail}</span> <a href='mailto:cloudsupport@hme.com' className='email'>e-mail</a>.</p>
      </div>
      <div className='trainingSection'>
        <Training />
      </div>
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Help.js